import { connect } from 'react-redux';

import {
  loadEnd,
  loadFail,
  loadStart,
} from 'actions/asyncActions';

import Load from 'components/general_panel/Load';

const mapStateToProps = state => ({
  isLoading: state.isLoading,
});

const mapDispatchToProps = dispatch => ({
  loadEnd: (newState, message) => {
    dispatch(loadEnd(newState, message));
  },

  loadFail: error => {
    dispatch(loadFail(error));
  },

  loadStart: () => {
    dispatch(loadStart());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Load);



// WEBPACK FOOTER //
// ./src/components/general_panel/containers/LoadContainer.js